// Copyright (c) Microsoft Corporation and others. Licensed under the MIT license.
// SPDX-License-Identifier: MIT
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()
export default history
